import { EventEmitter } from '@angular/core';

export let apiKitGlobals = {
  requiresMstrLogout: false,
  requiredADCMstrLogout: false,
  initialDatabankLogout: false,
};

export class ServiceUtils {
  public updateUserDetails: EventEmitter<any> = new EventEmitter<any>();
  public updateAccountDetails: EventEmitter<any> = new EventEmitter<any>();
  public orgData: any;

  public static getFullDomainName(domain: string) {
    let domainName;
    switch (domain) {
      case 'cfda':
        domainName = 'Assistance Listings';
        break;
      case 'opp':
        domainName = 'Contract Opportunities';
        break;
      case 'fpds':
        domainName = 'Contract Data';
        break;
      case 'ei':
        domainName = 'Entity Information';
        break;
      case 'ex':
        domainName = 'Exclusion Information';
        break;
      case 'fh':
        domainName = 'Federal Hierarchy';
        break;
      case 'wd':
        domainName = 'Wage Determination';
        break;
    }
    return domainName;
  }
}
